<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'ticket', 'suche', 'index']">
          <i class="fa fa-ticket"></i>
          Tickets
        </a>
      </li>
      <li>Ticket erstellen</li>
    </ul>
  </div>
</div>
<div class="page-content page-frame overflow-y-auto" *ngIf="isInitialized">
  <form [formGroup]="ticketForm" (submit)="createOrUpdateArticle()" class="page-sheet max-w-5xl mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Projektauswahl</legend>

        <label class="bm-fieldset-label">Projekt *</label>
        <ng-select
          class="w-full"
          [items]="projects"
          bindLabel="name"
          bindValue="id"
          formControlName="project_id"
          [loading]="loadingProjects"
          [virtualScroll]="true"
          (scrollToEnd)="fetchMoreProjects()"
          [required]="true"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
            @if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
              <div>
                {{ item.name }}
              </div>
            }
          </ng-template>
        </ng-select>

        <label class="bm-fieldset-label">Status</label>
        <ng-select
          [items]="projectStatuses"
          bindLabel="name"
          bindValue="id"
          formControlName="status_id"
          [loading]="loadingProjectStatuses"
          [required]="true"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="d-flex align-items-center gap-1">
              @if (item.closed) {
                <span class="fa fa-check-circle text-success"></span>
              }
              @if (item.canceled) {
                <span class="fa fa-ban text-error"></span>
              }
              @if (item.report_closed) {
                <span class="fa fa-hand-paper-o text-muted"></span>
              }
              <span>{{ item.name }}</span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
            @if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
              <div class="d-flex align-items-center gap-1">
                @if (item.closed) {
                  <span class="fa fa-check-circle text-success"></span>
                }
                @if (item.canceled) {
                  <span class="fa fa-ban text-danger"></span>
                }
                @if (item.report_closed) {
                  <span class="fa fa-hand-paper-o text-muted"></span>
                }
                <span>{{ item.name }}</span>
              </div>
            }
          </ng-template>
        </ng-select>

        <label class="bm-fieldset-label">Priorität</label>
        <ng-select
          class="w-full"
          [items]="priorities"
          bindLabel="name"
          bindValue="id"
          formControlName="priority_id"
          [loading]="loadingPriorities"
          [required]="true"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="d-flex align-items-center gap-1">
              @if (item.color) {
                <span class="fa-stack" style="font-size: 60%">
                  <i class="fa fa-circle fa-stack-2x" style="color: #333"></i>
                  <i class="fa fa-circle fa-stack-2x" [style.color]="item.color"></i>
                </span>
              } @else {
                <span>&nbsp;</span>
              }
              <span>{{ item.name }}</span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
            @if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
              <div class="d-flex align-items-center gap-1">
                @if (item.color) {
                  <span class="fa-stack" style="font-size: 60%">
                    <i class="fa fa-circle fa-stack-2x" style="color: #333"></i>
                    <i class="fa fa-circle fa-stack-2x" [style.color]="item.color"></i>
                  </span>
                } @else {
                  <span>&nbsp;</span>
                }
                <span>{{ item.name }}</span>
              </div>
            }
          </ng-template>
        </ng-select>

        <label class="bm-fieldset-label">Store</label>
        <ng-select
          class="w-full store-select"
          [items]="stores"
          bindLabel="name"
          bindValue="id"
          formControlName="store_id"
          [searchFn]="storeSearchFn"
          [loading]="loadingStores"
          [required]="true"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }}<br />
            <small>{{ item.address_city }}, {{ item.address_street }}</small>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
            @if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
              <div>
                {{ item.name }}<br />
                <small>{{ item.address_zip }} {{ item.address_city }}, {{ item.address_street }}</small>
              </div>
            }
          </ng-template>
        </ng-select>
      </fieldset>

      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Stammdaten</legend>

        <label class="bm-fieldset-label">Externe Auftragsnummer</label>
        <input class="bm-input w-full" type="text" formControlName="external_order_nr" />

        <label class="bm-fieldset-label">Fehlertext</label>
        <textarea
          class="bm-textarea w-full min-h-[180px]"
          placeholder="Fehlertext eingeben"
          formControlName="description"
        >
        </textarea>

        <label class="bm-fieldset-label">SLA-Datum</label>
        <div class="w-full flex flex-row gap-1">
          <div class="flex-1 bm-join">
            <input
              class="w-full bm-input bm-join-item"
              [matDatepicker]="datesla"
              formControlName="datesla_date"
              placeholder="Datum"
              (focus)="datesla.open()"
            />
            <mat-datepicker #datesla />
            <button class="bm-btn bm-join-item" (click)="datesla.opened ? datesla.close() : datesla.open(); (false)">
              <span class="fa fa-calendar"></span>
            </button>
          </div>

          <div class="flex-1 bm-join bm-join">
            <input
              class="w-full bm-input bm-join-item"
              [matTimepicker]="timepicker"
              formControlName="datesla_time"
              placeholder="Uhrzeit"
            />
            <mat-timepicker #timepicker />
            <button
              class="bm-btn bm-join-item"
              (click)="timepicker.opened ? timepicker.close() : timepicker.open(); (false)"
            >
              <span class="fa fa-clock"></span>
            </button>
          </div>
        </div>
      </fieldset>

      <!-- <fieldset class="bm-fieldset">
        <legend class="bm-fieldset-legend">
          <span>
            Weitere Felder
            @if (loadingticketFields) {
              <span>
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            }
          </span>
        </legend>

        @if (!loadingticketFields) {
          <div formGroupName="fields bm-fieldset">
            @for (field of fields.controls; track $index; let i = $index) {
              <div [formGroupName]="i" class="bm-fieldset">
                <label class="bm-fieldset-label">{{ field.value.name || field.value.description }}</label>
                @if (field.value.field_type == "LONGTEXT") {
                  <textarea class="bm-textarea w-full" formControlName="field_value"> </textarea>
                }
                @if (field.value.field_type == "TEXT") {
                  <input
                    class="bm-input w-full"
                    type="text"
                    formControlName="field_value"
                    [value]="field.value && field.value.id > 0 ? field.value.field_value : ''"
                    [placeholder]="field.value.name || field.value.description"
                  />
                }
              </div>
            }
          </div>
        }
      </fieldset> -->

      <div class="flex flex-row items-center justify-end gap-2 col-span-2">
        <a class="bm-btn" [routerLink]="['/', 'ticket', 'suche', 'index']">Abbrechen</a>
        <button
          class="bm-btn bm-btn-primary"
          [disabled]="!formLoaded || ticketForm.invalid || submittingTicket"
          type="submit"
        >
          Erstellen
        </button>
      </div>
    </div>
  </form>
</div>
